module.exports = __webpack_public_path__ + "Icono_Institucion_126px.png";